<template>
  <div class="fragment">
    <div class="input-col">
      <div class="form-textbox form-group">
        <div class="empty-spacer"></div>
        <div class="label-width">Sample</div>
        <div v-if="showAverageResults" class="label-width ml-2">Baseline</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SampleLabelControl',
  props: {
    showAverageResults: {
      type: Boolean
    }
  }
};
</script>

<style lang="scss" scoped>
.form-textbox {
  align-items: center;
  display: flex;
}

.empty-spacer {
  display: inline-block;
  min-width: 120px !important;
  width: 120px !important;
}

.label-width {
  width: 75px;
}

.result-average {
  margin-left: 5px;
}

.input-col {
  display: flex;
  flex-basis: 15%;
}
.ml-2 {
  margin-left: 8px;
}
</style>

